import { render } from "./StargeRemarketingMix.vue?vue&type=template&id=253dd598&scoped=true"
import script from "./StargeRemarketingMix.vue?vue&type=script&lang=js"
export * from "./StargeRemarketingMix.vue?vue&type=script&lang=js"

import "./StargeRemarketingMix.vue?vue&type=style&index=0&id=253dd598&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253dd598"]])

export default __exports__